module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir9-c08d049f3f1e8b4f099876f5a880c159.jpg";